import { Link } from 'react-router-dom';
import React from 'react';
import TEXTS from '../../../locale/texts';

export const allContactsGroupsColumns = (lang) => [
  {
    title: TEXTS.thGroupName[lang],
    width: 250,
    dataIndex: 'name',
    render: (text, record) => <Link
      className="ant-btn-link"
      to={`/phonebook/groups/${record.id}`}>
      {(typeof text === 'number' || typeof text === 'string') ? text : '—'}
    </Link>
  },
  {
    title: TEXTS.thContactsCount[lang],
    width: 200,
    dataIndex: 'contactCount',
    render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
  },
  {
    title: TEXTS.thBlackListCount[lang],
    width: 180,
    dataIndex: 'blackContactCount',
    render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
  },
  {
    title: TEXTS.comment[lang],
    dataIndex: 'note',
    render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
  }
];
